import { createSlice } from "@reduxjs/toolkit";

type Payload = {
  id: number;
  name: string;
};

type State = {
  payload: Payload;
};

const slice = createSlice({
  name: "kpiDepots",
  initialState: { payload: { id: 0, name: "All depots" } } as State,
  reducers: {
    getKPIDepots: (state, { payload }) => {
      state.payload = payload;
    }
  }
});

export const { getKPIDepots } = slice.actions;
export default slice.reducer;
